window.handleAddonRemovalIfRequired = async function (removeBtn) {
  console.log('handleAddonRemovalIfRequired');
  const item = removeBtn.closest('.cart-item');
  const loading__spinner = item.querySelectorAll('.loading-overlay');
  if (loading__spinner.length > 0) {
    loading__spinner.forEach((overlay) => overlay.classList.remove('hidden'));
  }
  const productOptions = item?.querySelectorAll('.product-option dt') || [];
  let isAddonProduct = false;
  let prod_addonId = '';
  let addofClicked = false;
  let uniqueId = '';
  for (const option of productOptions) {
    const text = option.innerText.trim();
    if (text === 'Add Ons:') {
      isAddonProduct = true;
    } else if (text === 'Addon Of:') {
      addofClicked = true;
    }
    else if (text === 'addonId:') {
      prod_addonId = option.nextElementSibling.innerText.trim();
    }
    else if (text === 'uniqueId:') {
      uniqueId = option.nextElementSibling.innerText.trim();
    }
  }
  if (isAddonProduct) {
    await window.handleAddonRemovalOnProductDelete(prod_addonId);
  } else if (addofClicked) {
    await window.handleAddonRemoval(uniqueId, item);
  }
};
window.handleAddonRemovalOnProductDelete = async function (prod_addonId) {
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await response.json();
    const addonItems = cart.items.filter(item => {
      const addonid = item.properties?.['uniqueId'];
      return prod_addonId === addonid; 
    });
    for (let addon of addonItems) {
      const newQuantity = addon.quantity > 1 ? addon.quantity - 1 : 0;
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: addon.key,
          quantity: newQuantity
        })
      });
    }
  } catch (error) {
    console.error('Error removing addon items:', error);
  }
};
window.handleAddonRemoval = async function (uniqueId,addonItem) {
  try {
    const addOnTitle = addonItem?.querySelector('.cart-item__name')?.innerText?.trim();
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const matchingProducts = cart.items.filter(item => {
      const addonId = item.properties?.['addonId'];
      return addonId === uniqueId;
    });
    if (matchingProducts.length === 0) return;
    for (const originalProduct of matchingProducts) {
    const currentAddOns = originalProduct.properties['Add Ons']
      .split('),').map(str => str.trim());
    const updatedAddOns = currentAddOns.filter(title => !title.includes(addOnTitle));
    const updatedProperties = { ...originalProduct.properties };
    if (updatedAddOns.length === 0) {
      delete updatedProperties['Add Ons'];
    } else {
        let temp = updatedAddOns.join('), ');
        if (temp[temp.length - 1] !== ')' && temp.length > 0) {
          temp += ')';
        }
      updatedProperties['Add Ons'] = temp;
    }
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: originalProduct.key,
        quantity: originalProduct.quantity,
        properties: updatedProperties
      })
    });
  }
  } catch (err) {
    console.error('Error updating add-on from original product:', err);
  }
};